export const formatName = (fn, ln) => {
    if (!fn && !ln) return 'Unknown';
    return `${fn} ${ln}`;
};
const NAME_PARTS = ['firstName', 'middleName', 'lastName'];

/**
 * The `show` keys of a record joined for display: "code - name" with a dash,
 * a person's name parts with a space ("System Administrator", where the dash
 * read "System -" / "Administrator" once the cell wrapped). Empty parts are
 * left out, so a missing one leaves no stray separator.
 */
export const extractValues = (obj, extractedKeys) => {
    const separator = extractedKeys.every((key) => NAME_PARTS.includes(key))
        ? ' '
        : ' - ';
    return extractedKeys
        .map((key) => obj?.[key] ?? '')
        .filter((part) => part !== '')
        .join(separator);
};

export const getExtractValue = (item, show, nestedObject = null, secondaryObject = null) => {
    if (!show) return '';

    const keys = show.split('+');

    if (nestedObject) {
        if (secondaryObject) {
            const secondaryValue = extractValues(
                item[secondaryObject] || {},
                keys
            );
            const nestedValue = extractValues(item[nestedObject] || {}, keys);
            return `${secondaryValue} - ${nestedValue}`;
        }
        return extractValues(item[nestedObject] || {}, keys);
    }

    return extractValues(item, keys);
};

export const formatController = (name) => {
    // Remove 'public' prefix if it exists
    // name = name.replace(/^public/, '');
    // Convert the first character to lowercase if needed
    name = name.charAt(0).toLowerCase() + name.slice(1);
    // Replace uppercase letters with '-lowercase' and convert all to lowercase
    name = name.replace(/([A-Z])/g, '-$1').toLowerCase();
    return name;
};

export function getNestedValue(obj, path) {
    if (!obj || !path) return undefined;
    return path
        .split('.')
        .reduce(
            (acc, key) =>
                acc && acc[key] !== undefined ? acc[key] : undefined,
            obj
        );
}
const jsonRegex = /^[{[].*[}\]]$/;
export const isValidJSON = (str) => {
    if (typeof str !== 'string' || !jsonRegex.test(str.trim())) return false;
    try {
        JSON.parse(str);
        return true;
    } catch {
        return false;
    }
};

export const normalizeTagsValue = (value) => {
    if (Array.isArray(value)) {
        return value.map((tag) => tag.trim());
    }
    if (typeof value === 'string') {
        return value.split(',').map((tag) => tag.trim());
    }
    return [];
};
